import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import styles from "./Navbar.module.css";
import logo from "../../assets/logo.svg";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showNavbar, setShowNavbar] = useState(true);
  const [scrolled, setScrolled] = useState(false);

  const lastScrollY = useRef(0);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }

      if (Math.abs(currentScrollY - lastScrollY.current) < 50) return;

      if (currentScrollY <= 0) {
        setShowNavbar(true);
      } else if (currentScrollY < lastScrollY.current) {
        setShowNavbar(true);
      } else {
        setShowNavbar(false);
      }

      lastScrollY.current = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavigate = (path) => {
    navigate(path);
    setMenuOpen(false);
  };

  return (
    <>
      <nav
        className={`${styles.navbar}
        ${showNavbar ? styles.showNav : styles.hideNav}
        ${scrolled ? styles.scrolled : ""}`}
      >
        {/* Logo */}
        <div className={styles.logo} onClick={() => handleNavigate("/")}>
          <img src={logo} alt="Baglami" />
        </div>

        {/* Center Menu */}
        <div className={styles.centerMenu}>
          <span
            className={`${styles.link} ${
              location.pathname === "/about" ? styles.active : ""
            }`}
            onClick={() => handleNavigate("/about")}
          >
            About Us
          </span>

          <span
            className={`${styles.link} ${
              location.pathname === "/menu" ? styles.active : ""
            }`}
            onClick={() => handleNavigate("/menu")}
          >
            Menus
          </span>

          <span
            className={`${styles.link} ${
              location.pathname === "/events" ? styles.active : ""
            }`}
            onClick={() => handleNavigate("/events")}
          >
            Events
          </span>
        </div>

        {/* Reservation Button */}
        <div className={styles.rightMenu}>
          <button
            className={styles.reservationBtn}
            onClick={() => handleNavigate("/reservation")}
          >
            Reservation
          </button>
        </div>

        {/* Mobile Toggle */}
        <div
          className={styles.menuToggle}
          onClick={() => setMenuOpen((prev) => !prev)}
        >
          ☰
        </div>
      </nav>

      {/* Mobile Menu */}
      <div
        className={`${styles.mobileMenu} ${
          menuOpen ? styles.showMobile : ""
        }`}
      >
        <div className={styles.mobileHeader}>
          <img src={logo} alt="Baglami" onClick={() => handleNavigate("/")} />
          <div
            className={styles.closeBtn}
            onClick={() => setMenuOpen(false)}
          >
            ✕
          </div>
        </div>

        <div className={styles.mobileLinks}>
          {[
            { path: "/about", label: "ABOUT" },
            { path: "/menu", label: "MENU" },
            { path: "/events", label: "EVENTS" },
            { path: "/career", label: "CAREER" },
            { path: "/contact", label: "CONTACT" },
            { path: "/reservation", label: "RESERVATIONS" },
          ].map((item) => (
            <span
              key={item.path}
              className={`${styles.mobileLink} ${
                location.pathname === item.path
                  ? styles.mobileActive
                  : ""
              }`}
              onClick={() => handleNavigate(item.path)}
            >
              {item.label}
            </span>
          ))}
        </div>
      </div>
    </>
  );
};

export default Navbar;